import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './AppRouter';
import { Layout } from './components/layout/Layout';
import { ThemeProvider } from './context/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Layout data-id="element-2">
          <AppRouter data-id="element-3" />
        </Layout>
      </BrowserRouter>
    </ThemeProvider>;
}